import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';

const CateringContentTwo = ({ 
    subtitle = "Kinder's Catering",
    body = "Legendary BBQ. Served your way.",
    colorMode = "colorBlack",
    imageUrl="/images/kinders-three-generations.jpg",
    imageAlt="Three Generations of Dedication to Quality and Service",
    headline="Three Generations. One Commitment.",
    copyText="Since 1946, the Kinder family has been obsessed with creating a warm, welcoming experience built on quality, comfort, and community. What started as a small butcher shop has become a local favorite, but our mission hasn't changed. We show up first. We treat customers like family. And we take pride in doing things the right way, every time.",
    reversed=false,
    buttonLabel="Learn More"
}) => {

  return (
    <div className="catering-hero-area">
      <div 
        className=""
        
      />
      
      {/* Content Container */}
      <div className="content-space-160-catering catering-content-wrapper">
        {/* Headlines Content */}
        <div className="columns catering-headlines is-flex is-flex-direction-column">
          {/* Main Title */}
          {subtitle && (
            <div className="py-0 column is-10-mobile is-offset-1-mobile is-8-desktop is-offset-2-desktop">
              <h2 className="m-0 p-0 cateringHead colorBlack is-align-center">
                {subtitle}
              </h2>
            </div>
          )}

          {/* Body */}
          {body && (
            <div className="py-0 column is-10-mobile is-offset-1-mobile is-8-desktop is-offset-2-desktop">
              <p className="m-0 p-0 big colorBlack is-align-center">
                {body}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CateringContentTwo;